import React, { createContext, useState, useEffect } from 'react';
export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userMetaData, setUserMetaData] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const safeParse = (item) => {
      try {
        return item ? JSON.parse(item) : null;
      } catch (e) {
        console.warn("Failed to parse item from localStorage:", item);
        return null;
      }
    };

    const storedUser = localStorage.getItem("user");
    const storedMeta = localStorage.getItem("userMetaData");
    const storedToken = localStorage.getItem("token");

    setUser(safeParse(storedUser));
    setUserMetaData(safeParse(storedMeta));
    setToken(storedToken || null);
  }, []);


  const login = (userData, userMetaData, jwtToken) => {
    setUser(userData);
    setUserMetaData(userMetaData);
    setToken(jwtToken);

    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("userMetaData", JSON.stringify(userMetaData));
    localStorage.setItem("token", jwtToken);
  };

  const logout = () => {
    setUser(null);
    setUserMetaData(null);
    setToken(null);

    localStorage.removeItem("user");
    localStorage.removeItem("userMetaData");
    localStorage.removeItem("token");
  };

  return (
    <UserContext.Provider
      value={{ user, setUser, userMetaData, setUserMetaData, token, setToken, login, logout }}
    >
      {children}
    </UserContext.Provider>
  );
};
